import React from 'react';
import './Brands.css';
const Brands = () => {
  return (
    <div className="brands-container">
      <p style={{margin: '4px', textAlign: 'center'}}>Clients featured in:</p>
      <div className="image-container">
      {[ 'cbs.png', 'josh-talks.jpeg', 'multiple.png', 'cbs.png', 'josh-talks.jpeg', 'multiple.png'].map((imageUrl, index) => {
        return (<img src={"./assets/channel-logos/" + imageUrl} alt="brand" height="72px" key={index}/>)
      })}
      </div>
    </div>
  )
};

export default Brands;